package net.gorillagroove.util

import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.launch
import net.gorillagroove.GGCommonInternal

open class EventHandlerRegistration<T> {
    private val registrations = mutableMapOf<Int, T>()

    private val lock = Lock()

    // Always invoke the callback on the Main thread because we almost always end up
    // using these event handlers to update bits of UI.
    // If I really care to do an IO dispatcher later, I can have the registration
    // sign up to be notified on the IO thread or something.
    private val scope = CoroutineScope(Dispatchers.Main)

    // Due to some stupid nonsense with KMP to iOS conversion, iOS can't use this function directly,
    // OR an overriden version that masks the generic type, because it either:
    // 1) gets mad about the generic function which it can't handle
    // 2) gets mad about needing to return KotlinUnit if you override without the generic
    // The only solution that works optimally is to just create a new function with a different name and call registerInternal.
    fun register(handler: T): Int {
        return lock.use {
            val id = (registrations.keys.maxOrNull() ?: 0) + 1
            registrations[id] = handler
            id
        }
    }

    internal fun broadcast(functionRunner: (T) -> Unit) {
        lock.use {
            registrations.values.forEach { registration ->
                if (GGCommonInternal.isIntegrationTesting) {
                    functionRunner(registration)
                } else {
                    scope.launch {
                        functionRunner(registration)
                    }
                }
            }
        }
    }

    open fun unregister(handlerId: Int) {
        lock.use {
            registrations.remove(handlerId)
        }
    }

    internal fun clear() {
        registrations.clear()
    }
}
